import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import getDay from 'date-fns/getDay'
import formatTime from 'date-fns/format'
import parseISO from 'date-fns/parseISO'
import { isNilEmpty } from 'Utils'
import SvgIcon from 'Components/SvgIcon'
import { weekdaysArray } from 'Utils/listingUtils'
import { _OpenHouseBanner } from './styles'

const OpenHouseBanner = ({ openHouses }) => {
  const [openHouseDate, setOpenHouseDate] = useState(null)
  useEffect(() => {
    if(!isNilEmpty(openHouses)) {
      try {
        const { date, to, from } = openHouses[0] || {}
        const day = getDay(parseISO(date))
        const start = formatTime(parseISO(`${date} ${from}`), 'h:mm')
        const end = formatTime(parseISO(`${date} ${to}`), 'h:mmaaa')
        setOpenHouseDate(`${weekdaysArray[day]} ${start}-${end}`)
      } catch(error) {
        //  eslint-disable-next-line
        console.log('Open house date error:', error)
      }
    }
  }, [openHouses])

  return openHouseDate ? (
    <_OpenHouseBanner>
      <SvgIcon name="#icon-openhouse" width={11} height={10} />
      <div>
        Open House
        <span>{openHouseDate}</span>
      </div>
    </_OpenHouseBanner>
  ) : null
}

OpenHouseBanner.propTypes = {
  openHouses: PropTypes.arrayOf(PropTypes.shape({})),
}

export default OpenHouseBanner
